"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agreementPricingFormSchema = void 0;
var zod_1 = require("zod");
var utils_1 = require("../../utils");
var priceField = zod_1.z
    .nullable(zod_1.z
    .string()
    .transform(function (val) { return val.replace(',', '.'); })
    .pipe((zod_1.z.coerce
    .number({ message: 'Valeur incorrecte' })
    .nonnegative({ message: 'Nombre négatif interdit' })
    .finite({ message: 'Valeur incorrecte' })))
    .transform(function (v) { return v * 100; })
    .transform(function (v) { return Number(v).toFixed(); })
    .transform(function (v) { return parseInt(v, 10); }))
    .default(null);
var percentField = zod_1.z
    .nullable(zod_1.z.coerce
    .number({ message: 'Valeur incorrecte' })
    .int({ message: 'Nombre entier requis' })
    .nonnegative({ message: 'Nombre négatif interdit' })
    .transform(function (v) { return v / 100; })
    .transform(function (v) { return v.toFixed(2); })
    .transform(parseFloat))
    .default(null);
var percentFloatField = zod_1.z
    .nullable(zod_1.z
    .string()
    .transform(function (val) { return val.replace(',', '.'); })
    .pipe((zod_1.z.coerce
    .number({ message: 'Valeur incorrecte' })
    .nonnegative({ message: 'Nombre négatif interdit' })))
    .transform(function (v) { return v / 100; })
    .transform(function (v) { return v.toFixed(3); }) // handle 0.925
    .transform(parseFloat))
    .default(null);
var yesNoFieldSchema = zod_1.z.enum(['YES', 'NO']).transform(function (v) { return v === 'YES'; });
exports.agreementPricingFormSchema = zod_1.z
    .object({
    startDate: zod_1.z.union([zod_1.z.string(), zod_1.z.date()]).pipe(zod_1.z.coerce.date()),
    type: zod_1.z.enum(['CPAM', 'CPAM_SEFI_GEO', 'CUSTOM']),
    isLastResort: yesNoFieldSchema.default(false),
    // * CPAM & CPAM_SEFI_GEO
    govPriceRate: percentFloatField,
    // * CUSTOM
    tollType: zod_1.z.enum(['VIA_MICHELIN', 'NONE', 'CUSTOM']).nullable().default(null),
    tollAmount: priceField,
    useDistanceMap: yesNoFieldSchema.default(false),
    kmIncludedInFlatFee: zod_1.z.coerce
        .number({ message: 'Valeur incorrecte' })
        .int({ message: 'Nombre entier requis' })
        .nonnegative({ message: 'Nombre négatif interdit' })
        .nullable()
        .default(null),
    pricePerKm: priceField,
    flatFee: priceField,
    nightRate: percentField,
    sundayRate: percentField,
    pooling2DiscountRate: percentField,
    pooling3DiscountRate: percentField,
    incubatorExtra: priceField,
    airportStationPortExtra: priceField,
    shortTripFeeTiers: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().optional(),
        distance: zod_1.z.coerce.number().int().nonnegative(),
        price: priceField,
    }))
        .default([]),
    // * COMMON
    waitingFee: priceField,
    noPatientFee: priceField,
})
    .superRefine(function (data, ctx) {
    if (data.type === 'CUSTOM') {
        if (!data.pricePerKm && !data.flatFee) {
            ctx.addIssue({
                path: ['pricePerKm'],
                message: "Ce champ est requis si le forfait de prise en charge n'est pas défini.",
                code: zod_1.z.ZodIssueCode.custom,
            });
            ctx.addIssue({
                path: ['flatFee'],
                message: "Ce champ est requis si le tarif kilométrique n'est pas défini.",
                code: zod_1.z.ZodIssueCode.custom,
            });
        }
    }
    if ((0, utils_1.isIn)(['CPAM', 'CPAM_SEFI_GEO'], data.type) && !data.govPriceRate) {
        ctx.addIssue({
            path: ['govPriceRate'],
            message: 'Ce champ est requis.',
            code: zod_1.z.ZodIssueCode.custom,
        });
    }
});
//# sourceMappingURL=bo-agreement-pricing-form.js.map